module.exports = __webpack_public_path__ + "img/horiz-logo.ec271f0c.png";